import { configureStore } from '@reduxjs/toolkit';
import userReducer from './userSlice';
import lookupReducer from './lookupSlice';
import menuReducer from './menuSlice';
import targetReducer from './targetSlice';
import actionFormReducer from './actionFormSlice';
import helperReducer from './helperSlice';
import dashboardReducer from './dashboardSlice';
import siteSettingsReducer from './siteSettingsSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    menu: menuReducer,
    lookup: lookupReducer,
    target: targetReducer,
    actionForm: actionFormReducer,
    helper: helperReducer,
    dashboard: dashboardReducer,
    siteSettings: siteSettingsReducer,
  },
});

export default store;
